import { render, staticRenderFns } from "./DocumentSchedule.vue?vue&type=template&id=188bacea&scoped=true"
import script from "./DocumentSchedule.vue?vue&type=script&lang=js"
export * from "./DocumentSchedule.vue?vue&type=script&lang=js"
import style0 from "./DocumentSchedule.vue?vue&type=style&index=0&id=188bacea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188bacea",
  null
  
)

export default component.exports